import { render, staticRenderFns } from "./SystemRule.vue?vue&type=template&id=0198de32&scoped=true"
import script from "./SystemRule.ts?vue&type=script&lang=ts&external"
export * from "./SystemRule.ts?vue&type=script&lang=ts&external"
import style0 from "./SystemRule.vue?vue&type=style&index=0&id=0198de32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0198de32",
  null
  
)

export default component.exports